import API from "../services/api-request.js";
export default {
  data() {
    return {
      partners: "",
      headTitle: 0,
      servicesToDisable: 0,
      partnersToWithdraw: 0,
      partnersToVerify: 0,
      partnersCount: 0,
    };
  },
  methods: {
    getData() {
      this.servicesToDisable = 0;
      this.partnersToWithdraw = 0;
      this.partnersToVerify = 0;
      this.partnersCount = 0;
      API.index("partner").then((response) => {
        this.partners = response.data.partners;
        this.partnersCount = this.partners.length;
        this.servicesToDisable = response.data.servicesToDisable;
        for (let index = 0; index < this.partners.length; index++) {
          if (
            this.partners[index].file &&
            this.partners[index].is_verified == 0
          ) {
            this.partnersToVerify += 1;
          }
          if (this.partners[index].withdraw == 1) {
            this.partnersToWithdraw += 1;
          }
        }
      });
    },
    verifyPartner(partnerId) {
      API.update(partnerId, { is_verified: true }, "partner").then(
        (response) => {
          this.getData();
          //# alert success
          this.$swal.fire({
            position: "top-end",
            icon: "success",
            title: "Partenaire vérifié",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      );
    },
    unverifyPartner(partnerId) {
      //# alert confirm suppression

      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Êtes vous sûres ?",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "OUI!",
          cancelButtonText: "Non, Annuler!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            API.update(partnerId, { is_verified: null }, "partner").then(
              (response) => {
                API.index("partner").then((response) => {
                  this.$swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Partenaire Non vérifié",
                    showConfirmButton: false,
                    timer: 1500,
                  });

                  this.getData();
                });
              }
            );
          }
        });
    },
    ValidatePayment(partnerId) {
      //# alert confirm suppression

      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Êtes vous sûres ?",
          text: "Avez vous remboursé le partenaire ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "OUI!",
          cancelButtonText: "NON!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            API.update(
              partnerId,
              { withdraw: false, wallet: "0" },
              "partner"
            ).then((response) => {
              swalWithBootstrapButtons.fire(
                "Succès !",
                "Partnenaire remboursé.",
                "success"
              );
              this.getData();
            });
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire("Cancelled", "", "error");
          }
        });
    },

    disableServices() {
      API.show("expired", "disable-services").then((response) => {
        //# alert success
        this.$swal.fire({
          position: "top-end",
          icon: "success",
          title: "Services desactivés",
          showConfirmButton: false,
          timer: 1500,
        });
        this.getData();
      });
    },
    unableServices() {
      API.show("expired", "unable-services").then((response) => {
        this.$swal.fire({
          position: "top-end",
          icon: "success",
          title: "Services activés",
          showConfirmButton: false,
          timer: 1500,
        });
        this.getData();
      });
    },
  },
  mounted() {
    this.getData();
  },
};
